// hc-shipping-bar-ltl.js
// Patches the Impact theme's <free-shipping-bar> custom element so that LTL
// (freight) items are excluded from the eligible cart total. LTL product/variant
// IDs are injected by hc-ltl-data.liquid as window.HC_LTL_PRODUCT_IDS / _VARIANT_IDS.
//
// Strategy: wait for free-shipping-bar to be defined, then replace its
// _onCartChanged prototype method with an LTL-aware version. The original method
// in theme.js sums all items where requires_shipping is true; we additionally
// drop items whose product_id or variant_id is in the LTL sets.

(function () {
  'use strict';

  if (!window.customElements) return;

  customElements.whenDefined('free-shipping-bar').then(function () {
    var FSB = customElements.get('free-shipping-bar');
    if (!FSB || !FSB.prototype) return;
    if (FSB.prototype._hcLtlPatched) return;

    FSB.prototype._hcLtlPatched = true;

    var locale = (window.Shopify && Shopify.locale) || 'en-US';
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var noDecimalFormatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    // Override _updateMessage to:
    //   - render a static "Spend $99+ on eligible items..." message when cart is empty
    //     (progress bar is hidden via CSS in that state)
    //   - otherwise render the standard "Spend $X more" message using the bar's own formatter
    FSB.prototype._updateMessage = function () {
      var messageElement = this.querySelector('span');
      if (!messageElement) return;

      if (this.dataset.cartEmpty === 'true') {
        var thresholdLabel = noDecimalFormatter.format(this.threshold / 100);
        messageElement.innerHTML =
          'Spend <span class="bold text-accent">' + thresholdLabel + '+</span> on eligible items to unlock free shipping.';
        return;
      }

      if (this.totalPrice >= this.threshold) {
        messageElement.innerHTML = this.getAttribute('reached-message');
      } else {
        var fmt = this._currencyFormatter || noDecimalFormatter;
        var replacement = '<span class="bold text-accent">' +
          fmt.format((this.threshold - this.totalPrice) / 100).replace(/\$/g, '$$$$') +
          '</span>';
        messageElement.innerHTML = this.getAttribute('unreached-message').replace(new RegExp('({{.*}})', 'g'), replacement);
      }
    };

    FSB.prototype._onCartChanged = function (event) {
      var cart = event && event.detail && event.detail.cart;
      if (!cart) return;

      var ltlProducts = new Set(window.HC_LTL_PRODUCT_IDS || []);
      var ltlVariants = new Set(window.HC_LTL_VARIANT_IDS || []);

      var items = (cart.items || []).filter(function (item) {
        if (!item.requires_shipping) return false;
        if (ltlProducts.has(item.product_id)) return false;
        if (ltlVariants.has(item.variant_id)) return false;
        return true;
      });

      var priceForItems = items.reduce(function (sum, item) {
        return sum + (item.final_line_price || 0);
      }, 0);

      var cartDiscount = (cart.cart_level_discount_applications || []).reduce(function (sum, d) {
        return sum + (d.total_allocated_amount || 0);
      }, 0);

      var prevEmpty = this.dataset.cartEmpty;
      var nowEmpty = (cart.items || []).length === 0 ? 'true' : 'false';
      this.dataset.cartEmpty = nowEmpty;

      this.totalPrice = priceForItems - cartDiscount;

      // If empty-state changed, the message style changes too — force a refresh
      // since totalPrice may not have changed (both states could be 0).
      if (prevEmpty !== nowEmpty && typeof this._updateMessage === 'function') {
        this._updateMessage();
      }
    };

    // Re-bind existing instances. Their constructor captured the ORIGINAL
    // _onCartChanged into _onCartChangedListener before this patch ran, so
    // without re-binding they keep using the unpatched handler.
    document.querySelectorAll('free-shipping-bar').forEach(function (el) {
      if (el._onCartChangedListener) {
        document.removeEventListener('cart:change', el._onCartChangedListener);
      }
      el._onCartChangedListener = FSB.prototype._onCartChanged.bind(el);
      document.addEventListener('cart:change', el._onCartChangedListener);
      if (typeof el._updateMessage === 'function') el._updateMessage();
    });
  });
})();
